import { ErrorBoundary } from 'react-error-boundary';
import { PLUS_HOME_PAGE_PATHS } from '@cx-web/repub-config';
import { getRepubHomeUrl } from '@cx-web/utils';
import { captureException, captureRemixErrorBoundaryError } from '@sentry/remix';

import { type Repub } from '@cx-modules/constants';
import PremiumSignupModule from '@cx-modules/premium-signup';

export type PremiumSignupProps = {
  accountDetailsTitle?: string;
  ageVerificationAndConsent?: string;
  apiKey: string;
  ctaText?: string;
  dataApiEndpoint: string;
  deviceId: string;
  firstNameLabel?: string;
  fullNameLabel?: string;
  loginTextAndLink?: string;
  newsletterSignupConsent?: string;
  passwordLabel?: string;
  paymentMethodTitle?: string;
  productId: string;
  repub: Repub;
  requestUrl?: string;
  returnUrl?: string;
  signupIntro?: string;
  signupTitle?: string;
  stripePublishableKey: string;
  subscriptionInformationText?: string;
  surnameLabel?: string;
};

export const PremiumSignup = (props: PremiumSignupProps) => {
  const handleSuccess = (_customerEmail: string) => {
    const plusPath = PLUS_HOME_PAGE_PATHS[props.repub as keyof typeof PLUS_HOME_PAGE_PATHS] ?? '/plus';
    window.location.href = plusPath;
  };

  const handleError = (error: Error) => {
    captureException(error);
    window.location.href = getRepubHomeUrl(props.repub);
  };

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureRemixErrorBoundaryError(error);
        return null;
      }}
    >
      <PremiumSignupModule {...props} loadingElement={null} onError={handleError} onSuccess={handleSuccess} />
    </ErrorBoundary>
  );
};
